import { Capacitor, registerPlugin } from '@capacitor/core'
import type { Router } from 'vue-router'

/**
 * Android App Links: an https://app.refuelled.app/… link opened on the phone
 * lands in the app rather than the browser, once the host publishes
 * /.well-known/assetlinks.json naming this app's signing certificate. The
 * one that matters today is a provider's OAuth callback, which the system
 * browser would otherwise finish on the website, signed in or not.
 *
 * The App plugin ships with the mobile shell; the web app reaches it by
 * name rather than importing the package, as it does for the status bar.
 */
interface AppPlugin {
  addListener(event: 'appUrlOpen', fn: (data: { url: string }) => void): Promise<{ remove: () => Promise<void> }>
}
const App = registerPlugin<AppPlugin>('App')

export function routeAppLinks(router: Router): void {
  if (!Capacitor.isNativePlatform()) return
  void App.addListener('appUrlOpen', ({ url }) => {
    try {
      const target = new URL(url)
      if (target.hostname !== 'app.refuelled.app') return
      // Only the path is routed: the host is ours by construction of the filter.
      void router.push(target.pathname + target.search)
    } catch {
      // Not a URL we can read; the browser can have it.
    }
  })
}
